import { Card, Divider, Grid, Typography } from '@mui/material';
import PropTypes from 'prop-types';
import React, { useState } from 'react';
import { useFormContext } from 'react-hook-form';
import FormButtonOptions from '../../../FormFields/FormButtonOptions';
import FormTitle from '../../../FormFields/FormTitle';
import { formCardStyle } from '../../../TransitionStyles';
import { HR } from '../../../formQuestionsEnum';
import StaffOnLeaveSection from './StaffOnLeaveSection';
import StaffOnADASection from './StaffOnADASection';
import FormStaffInfoFieldWithDiffDept from '../../../FormFields/StaffInfoField/FormStaffInfoFieldWithDiffDept';

FMLAForm.propTypes = {
  permissions: PropTypes.object,
};

export default function FMLAForm({ permissions }) {
  const { watch } = useFormContext();
  const isStaffOnLeave = watch(HR.IS_STAFF_ON_LEAVE.fieldName);
  const isStaffOnADA = watch(HR.IS_STAFF_ON_ADA.fieldName);
  const [focusedField, setFocusedField] = useState(null);

  const fieldIds = [
    HR.HR_DIRECTOR.id,
    HR.HR_AND_PAYROLL_SAME_PERSON.id,
    HR.IS_STAFF_ON_LEAVE.id,
    HR.STAFF_ON_LEAVE.id,
    HR.IS_STAFF_ON_ADA.id,
    HR.STAFF_ON_ADA.id,
  ];

  const showForm = fieldIds.some((id) => id in permissions);

  return (
    showForm && (
      <Card sx={formCardStyle}>
        <Typography sx={{ mb: 1 }} align="center" variant="body1" color="info.main">
          FMLA etc.
        </Typography>
        <Divider sx={{ mb: 1, mt: 2, borderWidth: 1 }} />
        <Grid container spacing={1.5}>
          {HR.HR_DIRECTOR.id in permissions && (
            <Grid item xs={12}>
              <FormStaffInfoFieldWithDiffDept
                fieldName={HR.HR_DIRECTOR.fieldName}
                fieldAttributes={{
                  isEditable: permissions[HR.HR_DIRECTOR.id],
                  questionTitle: 'Current HR director',
                  fieldName: HR.HR_DIRECTOR.fieldName,
                }}
                focusedField={focusedField}
                setFocusedField={setFocusedField}
              />
            </Grid>
          )}

          {HR.HR_AND_PAYROLL_SAME_PERSON.id in permissions && (
            <Grid item xs={12}>
              <FormTitle fieldAttributes={{ questionTitle: 'Are facility HR and payroll the same person?' }} />
              <FormButtonOptions
                fieldName={HR.HR_AND_PAYROLL_SAME_PERSON.fieldName}
                fieldAttributes={{
                  isEditable: permissions[HR.HR_AND_PAYROLL_SAME_PERSON.id],
                  options: [
                    { label: 'Yes', value: true },
                    { label: 'No', value: false },
                  ],
                }}
              />
            </Grid>
          )}

          {HR.IS_STAFF_ON_LEAVE.id in permissions && (
            <Grid item xs={12}>
              <FormTitle
                fieldAttributes={{ questionTitle: 'Is anyone out on FMLA, LOA, workers comp or restricted duty?' }}
              />
              <FormButtonOptions
                fieldName={HR.IS_STAFF_ON_LEAVE.fieldName}
                fieldAttributes={{
                  isEditable: permissions[HR.IS_STAFF_ON_LEAVE.id],
                  options: [
                    { label: 'Yes', value: true },
                    { label: 'No', value: false },
                  ],
                }}
              />
            </Grid>
          )}

          {HR.STAFF_ON_LEAVE.id in permissions && isStaffOnLeave && (
            <StaffOnLeaveSection
              focusedField={focusedField}
              setFocusedField={setFocusedField}
              isEditable={permissions[HR.STAFF_ON_LEAVE.id]}
            />
          )}

          {HR.IS_STAFF_ON_ADA.id in permissions && (
            <Grid item xs={12}>
              <FormTitle fieldAttributes={{ questionTitle: 'Is anyone on ADA?' }} />
              <FormButtonOptions
                fieldName={HR.IS_STAFF_ON_ADA.fieldName}
                fieldAttributes={{
                  isEditable: permissions[HR.IS_STAFF_ON_ADA.id],
                  options: [
                    { label: 'Yes', value: true },
                    { label: 'No', value: false },
                  ],
                }}
              />
            </Grid>
          )}

          {HR.STAFF_ON_ADA.id in permissions && isStaffOnADA && (
            <StaffOnADASection
              focusedField={focusedField}
              setFocusedField={setFocusedField}
              isEditable={permissions[HR.STAFF_ON_ADA.id]}
            />
          )}
        </Grid>
      </Card>
    )
  );
}
